import { useMemo } from "react";

import { useUserContext } from "../Context/UserContext";
import { isAdmin } from "./permissions";

export const useHasAdminRoleMustHaveUser = () => {
  const { userModel } = useUserContext({ allowNull: false });

  return useMemo(() => isAdmin(userModel?.roles), [userModel?.roles]);
};

export const useHasAdminOrSaasAdminRoleMustHaveUser = () => {
  const { userModel } = useUserContext({ allowNull: false });

  return useMemo(() => isAdmin(userModel?.roles), [userModel?.roles]);
};
